// components/common/TableActions/TableActions.jsx
import React from "react";
import {
  Stack,
  IconButton,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { EditOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { styledClass } from "../../../utils/constants";

const TableActions = ({
  row,
  currentPage,
  actions = {},
  basePath = "",
  onView,
  onEdit,
  onDelete,
  onBlock,
  customActions = [],
}) => {
  const navigate = useNavigate();
  
  const {
    showView = true,
    showEdit = true,
    showBlock = true,
    showDelete = true,
  } = actions;

  const handleView = () => {
    if (onView) {
      onView(row);
    } else if (basePath) {
      navigate(`${basePath}/view/${row._id}?page=${currentPage}`);
    }
  };

  const handleEdit = () => {
    if (onEdit) {
      onEdit(row);
    } else if (basePath) {
      navigate(`${basePath}/view/${row._id}?page=${currentPage}`, {
        state: "edit",
      });
    }
  };

  const handleDelete = () => {
    if (onDelete) {
      onDelete(row._id);
    }
  };

  const handleBlock = () => {
    if (onBlock) {
      onBlock(row._id);
    }
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="center"
    >
      {showView && (
        <Tooltip title="View" placement="top">
          <IconButton
            sx={styledClass("viewIcon")}
            onClick={handleView}
          >
            <VisibilityIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      
      {showEdit && (
        <Tooltip title="Edit" placement="left">
          <IconButton
            sx={styledClass('edit')}
            onClick={handleEdit}
          >
            <EditOutlined />
          </IconButton>
        </Tooltip>
      )}
      
      {showBlock && (
        <Tooltip title={row?.isLocked ? "Unblock" : "Block"} placement="top">
          <IconButton
            sx={styledClass(row?.isLocked ? "unlockIcon" : "lockIcon")}
            onClick={handleBlock}
          >
            {row?.isLocked ? (
              <LockOpenIcon fontSize="small" />
            ) : (
              <LockIcon fontSize="small" />
            )}
          </IconButton>
        </Tooltip>
      )}
      
      {showDelete && (
        <Tooltip title="Delete" placement="top">
          <IconButton
            sx={styledClass("deleteIcon")}
            onClick={handleDelete}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      
      {/* Custom actions */}
      {customActions.map((action, index) => (
        <Tooltip key={index} title={action.tooltip} placement="top">
          <IconButton
            sx={action.sx || {}}
            onClick={() => action.onClick(row)}
          >
            {action.icon}
          </IconButton>
        </Tooltip>
      ))}
    </Stack>
  );
};

export default TableActions;